import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import io from 'socket.io-client';

let socketInstance;

const useSocket = (action) => {
  const serverUrl = `${process.env.REACT_APP_API_URL}`;

  const { userDetails } = useSelector((state) => state.user);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (action === 'connect') {
      if (!userDetails) {
        if (socketInstance) {
          socketInstance.disconnect();
        }
        return;
      }
      if (!socketInstance) {
        socketInstance = io(serverUrl, {
          transports: ['websocket'],
          path: '/socket'
        });

        socketInstance.on('connect', () => {
          console.log('Socket Connected');
        });

        socketInstance.on('reconnecting', (attempt) => {
          console.log('Socket reconnecting, attempt: ' + attempt);
        });

        socketInstance.on('reconnect', (attempt) => {
          console.log('Socket Reconnected, attempt: ' + attempt);
        });

        socketInstance.on('connect_error', (err) => {
          console.log(`Socket connection error due to ${err.message}`);
        });
        socketInstance.on('message', (data) => {
          console.log('Message received:', data);
        });
      }

      setSocket(socketInstance);

      return () => {
        if (socketInstance) {
          console.log('Socket Disconnected');
          socketInstance.disconnect();
          setSocket(null);
        }
        // Don't close the connection when a component unmounts
        // Keep the connection alive until the application unmounts
        // if you want to close the connection when the last component using it unmounts, you can add that logic here
      };
    }
  }, [serverUrl, userDetails, action]);

  const socketUpdate = (event, callback) => {
    if (!socketInstance) return callback(null);
    console.log('Socket on: ', event);
    socketInstance.on(`${event}-${userDetails._id}`, (data) => {
      console.log('Message received:', event, data);
      callback(data);
    });
  };

  const socketOff = (event) => {
    if (!socketInstance) return;
    console.log('Socket off: ', event);
    socketInstance.off(`${event}-${userDetails._id}`);
  };

  return { socket, socketUpdate, socketOff };
};

export default useSocket;
